import { useQuery } from "react-query";
import { useDispatch } from "react-redux";

import { getErrorMessage } from "helpers";
import { mapUserProfileDataFromServer } from "mappers";
import { usersService } from "services";
import { uiActions } from "store";
import { ErrorResponse } from "types";

const useGetUserProfileQuery = () => {
	const dispatch = useDispatch();

	const queryResult = useQuery(
		["getUserProfileQuery"],
		() => usersService.getUserProfileData(),
		{
			select(data: { [key: string]: any }) {
				return mapUserProfileDataFromServer(data);
			},
			onError(error: ErrorResponse) {
				dispatch(
					uiActions.showErrorNotification({
						title: getErrorMessage(error),
					}),
				);
			},
		},
	);

	return queryResult;
};

export default useGetUserProfileQuery;
